export default __webpack_public_path__ + "static/media/icon-location-d.c0eb5e56.svg";